import { render, staticRenderFns } from "./ViewPort.vue?vue&type=template&id=27935ba2&scoped=true&"
import script from "./ViewPort.vue?vue&type=script&lang=js&"
export * from "./ViewPort.vue?vue&type=script&lang=js&"
import style0 from "./ViewPort.vue?vue&type=style&index=0&id=27935ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27935ba2",
  null
  
)

export default component.exports